export const MAX_EMAIL_LENGTH = 255;

export const isValidEmail = (value: string): boolean => {
	if (value.length > MAX_EMAIL_LENGTH) return false;
	const atIndex = value.indexOf("@");
	const hasValidAt = atIndex > 0 && atIndex < value.length - 1;
	return hasValidAt && value.slice(atIndex + 1).includes(".");
};
